// extracted by mini-css-extract-plugin
export default {"container":"JO4onjfykrvjNJbM1CeN__container___","label":"H0r7fdJlkipJNbJtFl_9__label___"};